import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../components/Styles/Registration.css';
import bgImage from '../../images/Resort2.png';
import PartnerModal from '../../components/PartnerRegistration/PartnerModal';
import HeroSection from '../../components/PartnerRegistration/step1page/HeroSection';
import GetStartedSection from '../../components/PartnerRegistration/step1page/GetStartedSection';
import WhyPartnerSection from '../../components/PartnerRegistration/step1page/WhyPartnerSection';
import FAQSection from '../../components/PartnerRegistration/step1page/FAQSection';

const ClientRegistration = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const handleVenueRegistration = () => {
    navigate('/partner/registration/venue');
  };

  const handleEventRegistration = () => {
    navigate('/partner/registration/event');
  };

  const handleTempleRegistration = () => {
    navigate('/partner/registration/temple');
  };

  return (
    <div>
      <HeroSection bgImage={bgImage} toggleModal={toggleModal} />
      <GetStartedSection />
      <WhyPartnerSection />
      <FAQSection />
      <PartnerModal
        isVisible={isModalVisible}
        onClose={toggleModal}
        handleVenueRegistration={handleVenueRegistration}
        handleEventRegistration={handleEventRegistration}
        handleTempleRegistration={handleTempleRegistration}
      />
    </div>
  );
};

export default ClientRegistration;
